<!--
입고스캔 > 입고내역 리스트 컴포넌트
------------------------------------
-->
<template>
    <div class="uk-padding">

        <!-- 선택 일괄기능 -->
        <app-batch-controller :batch="batch" class="uk-margin-bottom uk-text-large" hide-none-checked>
            <app-batch-job-ship-in
                slot="jobs"
                :batch="batch"
                :csrf-token="csrfToken"
            ></app-batch-job-ship-in>
        </app-batch-controller>

        <!-- 입고내역 리스트-->
        <div class="uk-flex uk-flex-between uk-flex-bottom">
            <div class="uk-text-large">
                <i class="material-icons uk-text-bottom" style="font-size: 32px">
                    done_all
                </i>
                입고스캔완료 ({{ shipInList.length }})
            </div>

            <div class="uk-text-danger uk-text-large">
                * 선택시, 삭제할 수 있습니다
            </div>
        </div>




        <div class="uk-card uk-card-default">

            <table class="prod-info">
                <colgroup>
                    <col style="width: 100px">
                    <col style="width: 120px">
                    <col style="width: 120px">

                    <col>
                    <col style="width: 180px">

                    <col style="width: 180px">
                    <col style="width: 180px">

                </colgroup>
                <thead>
                <tr>

                    <th>
                        <!-- 전체선택 -->
                        <app-batch-all-item-checker :items="batch.items" style="width: 26px; height: 26px;"></app-batch-all-item-checker>
                    </th>

                    <th>
                        센터
                    </th>
                    <th>
                        번호
                    </th>



                    <th class="scanned_no">
                        스캔번호
                    </th>
                    <th>
                        분류결과
                    </th>

                    <th>
                        긴급입고
                    </th>
                    <th>
                        입고라벨
                    </th>

                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="(ship_in, index) in shipInList"
                >
                    <td>
                        <app-batch-item-checker :item="ship_in" style="width: 26px; height: 26px; margin-top: 6px"></app-batch-item-checker>
                    </td>

                    <td>
                        <i class="material-icons">{{ ship_in.center.transport_material_icon }}</i>
                        {{ ship_in.center.transport_text }}
                    </td>
                    <td>
                        {{ ship_in.id }}
                    </td>



                    <td class="scanned_no">
                        {{ ship_in.scanned_no }}
                    </td>
                    <td>
                        {{ ship_in.classification_text }}
                    </td>

                    <td>
                        {{ ship_in.urgent_type_text }}
                    </td>
                    <td>
                        <div class="uk-text-center uk-margin-top" v-show="ship_in.urgent_type === 1 || ship_in.classification !== 1">
                            <button
                                type="button"
                                class="uk-button uk-button-default"
                                @click="$parent.printShipInLabel(ship_in.id)"
                            >
                                <i class="material-icons">print</i>
                                <span class="text">입고라벨</span>
                            </button>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>

        </div>

    </div>
</template>

<script>
    export default {

        props: {
            // csrf-token
            csrfToken: String,

            /**
             * 지역id
             */
            regionId: {
                type: Number,
                default: null,
            },

            /**
             * 입고스캔내역
             */
            shipInList: {
                type: Array,
                default: null,
            },
        },
        data: function () {

            return {
                // 전체선택에 사용할 일괄정보 객체
                batch: {
                    title: '입고기록 일괄작업',
                    items: this.shipInList,
                    checked_item_count: 0,
                    item_checked_msg_format: 'checked :count items',
                    item_checked_nothing_msg: 'No item selected',
                },
            };
        },
        computed: {

        },

        methods: {
        },
    }
</script>

<style lang="scss" scoped>
    .prod-info {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;

        .material-icons {
            vertical-align: middle;
            font-size: 2rem
        }

        th {
            background-color: #fafafa;
        }

        th, td {
            font-size: 1.5rem;
            text-align: center;
            padding: 10px;
            font-weight: normal;

            &.scanned_no {
                text-align: left;
            }

            border: 1px solid #cfcfcf;
        }

        td {
            &.scanned_no {
                font-size: 2rem;
            }
        }

        tr:hover td {
            background-color: #e6f5ff;
        }



    }
</style>